(function() {

	"use strict";

	/**
	 * Api queries entry point
	 *
	 * @param entrypoint
	 * @param params
	 */
		angular.module("ATMGApi")
			.factory("ApiQuery", [
			"$http",
			"$q",
			"ATMGConf",
			"ErrorService",
			"$state",
			'$localStorage',
			function( $http, $q, Conf, ErrorService, $state, $storage) {

				return function( endpoint, parms, method, headers ) {

					var http_method = method  ? method : "POST";
					var  defer = $q.defer();

					/**
					*	GET Querystring
					*
					*	if GETting we might need to have some urlencoded parameters
					* 	if it's a string it means the method firing the request has some special needs, so it takes care of formatting
					* 	if an object is coming in we just urlencode and stringify it
					*/
					if ( method === "GET" && parms &&  typeof parms !== undefined ) {

						var queryString = undefined;

						if ( typeof parms === 'object' ) {
							var stringifiedWhere = [];

							queryString = "f=" + encodeURIComponent( JSON.stringify( parms ) );
						}
						else {
							queryString = parms;
						}

						endpoint = endpoint + "?" + queryString;
						parms = undefined;
					}

					// define headers
					if (angular.isDefined(headers)) {
						if (!angular.isDefined( headers['Content-Type'])) {
							headers['Content-Type'] = 'application/json'
						}
					}
					else {
						headers = {
							'Content-Type': 'application/json',
							'Site-Host': 'www.atmgurus.com',
							// 'X-Requested-With': 'XMLHttpRequest',
							'Authorization': $storage.token,
							// 'Accepts': 'application/json'
						}
					}

					if (typeof $storage.token !== 'undefined') {
						headers.Authorization = $storage.token
					}

					$http({
						method: http_method,
						url: API_ROOT + endpoint,
						data: parms,
						headers: headers,
					})
						.then( function( response, status ) {

							defer.resolve( response );

							// Deal with warnings
							if (angular.isDefined(response.warning)) {

								// in case the warning is for the address selection we wanna show it inside the  checkout shipping address module
								if ( /customer\/addresses/.test( endpoint ) ) {
									ErrorService.set( response.warning, 'addressBook' )
								}

								else if ( /cart\/view/.test( endpoint ) ) {
									ErrorService.set( response.warning, 'confirmation' )
								}

								else {
									// ErrorService.set( response.warning, "applicationWide")
									// @TODO accumulate warning messages before displaying them
									if (response.warning[0].modal) {
										ErrorService.setGeneralError(response.warning[0].message, "warning");
									}
								}
							}
						})

						.catch( function( reason, status ) {
							switch ( status ) {
								case 401:
									ErrorService.set(reason.message, "authError");
									$state.go("login")
									defer.reject( reason );
									break;
								case 400:
									// explicitly handle the case we're checking for a company number
									// prevent double modals to be fired
									if ( ! /customer\/check/.test( endpoint ) ) {
										ErrorService.setGeneralError( reason.message, "error", reason.data )
										defer.reject( reason );
										break;
									}
								case 404:
									defer.reject( 404 );
									break;
								default:
									defer.reject( reason )
							}
						})
					return defer.promise;
				}
			}
		])
})()


// WEBPACK FOOTER //
// ./src/app/modules/ATMGApi/factories/ApiQuery.js